var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTitleBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1091,
    height: 226,
    viewBox: "0 0 1091 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1068.77 208.195L840.325 25.1953C838.551 23.7743 836.346 23 834.073 23H96C90.4771 23 86 27.4772 86 33V216C86 221.523 90.4771 226 95.9999 226H1062.52C1071.97 226 1076.15 214.103 1068.77 208.195Z",
    fill: "#FAF2D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1007.07 187.115L773.748 5.1151C771.991 3.74443 769.826 3 767.598 3H13C7.47717 3 3 7.47715 3 13V195C3 200.523 7.47717 205 13 205H1000.92C1010.44 205 1014.57 192.967 1007.07 187.115Z",
    fill: "white",
    stroke: "#5CD2E6",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleBg);
export default __webpack_public_path__ + "static/media/title_bg.6fef780d72f29490457e189be559cec2.svg";
export { ForwardRef as ReactComponent };